import React from "react";
import { inject, observer } from "mobx-react";
import { Label } from "react-bootstrap";
import { Link } from "react-router-dom";
import MaintenanceAgencyLabel from "../detail/MaintenanceAgencyLabel";

const charLimit = 150;

@inject("searchStore")
@observer
export class SearchResultsItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.getUrl = this.getUrl.bind(this);
  }

  toggleExpanded() {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  }

  getUrl() {
    const { getSelectedFramework } = this.props.searchStore;
    const { type, tid } = this.props;
    if (type.toLowerCase() === "variable" && getSelectedFramework)
      return `/view/${type}/${tid}?framework=${getSelectedFramework?.name}`;
    else return `/view/${type}/${tid}`;
  }

  getTitle(withLinks = true) {
    const { getMetadata } = this.props.searchStore;
    const { type, maintenanceAgencyId } = this.props;
    const meta = getMetadata[type];
    const fieldsToDisplay = meta.fieldsForSearchResultView;
    const titleItems = [];

    if (fieldsToDisplay.findIndex((field) => field.includes("name")) !== -1) {
      withLinks === true
        ? titleItems.push(
            <Link key="title-name" className="object-name" to={this.getUrl()}>
              {this.props.name}
            </Link>
          )
        : titleItems.push(<span key="title-name">{this.props.name}</span>);
    }

    // specific case for LegalText until fully generic rendering is introduced (e.g. metadata could contain field names for constructing title)
    if (
      fieldsToDisplay.findIndex((field) => field.includes("legalCode")) !== -1
    ) {
      withLinks === true
        ? titleItems.push(
            <Link
              key="title-legalCode"
              className="object-name"
              to={this.getUrl()}
            >
              {this.props.legalCode}
            </Link>
          )
        : titleItems.push(
            <span key="title-legalCode">{this.props.legalCode}</span>
          );
    }

    const codeField = fieldsToDisplay.find((field) =>
      field.toLowerCase().includes("code")
    );
    if (codeField) {
      const code = this.props[codeField];
      titleItems.push(<span key="title-code">({code})</span>);
    }

    if (withLinks === true) {
      titleItems.push(
        <Label key="title-type" className="object-type" bsStyle="success">
          {type}
        </Label>
      );
    }

    if (maintenanceAgencyId) {
      titleItems.push(
        <MaintenanceAgencyLabel
          maintenanceAgencyId={maintenanceAgencyId}
        ></MaintenanceAgencyLabel>
      );
    }

    return <div className="title">{titleItems}</div>;
  }

  render() {
    const { getMetadata } = this.props.searchStore;
    const meta = getMetadata[this.props.type];
    const { maintenanceAgencyId, isFramework } = this.props;
    if (!meta) {
      return null;
    }
    const { expanded } = this.state;

    const descriptionField = meta.fieldsForSearchResultView.find((field) =>
      field.toLowerCase().includes("description")
    );
    let description;
    if (descriptionField) {
      description = this.props[descriptionField];
    }
    //description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    return isFramework ? (
      <Link key="title-name" className="object-name" to={this.getUrl()}>
        <div
          className={`item ${
            maintenanceAgencyId === "ECB" ? "reference" : "non-reference"
          }`}
        >
          {this.getTitle(false)}
        </div>
      </Link>
    ) : (
      <div
        className={`item ${
          maintenanceAgencyId === "ECB" ? "reference" : "non-reference"
        }`}
      >
        {this.getTitle()}

        {description ? (
          <div className="object-description">
            {expanded
              ? description + ` `
              : `${description.substring(0, charLimit)}...`}
            {description.length > charLimit ? (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a
                onClick={() => this.toggleExpanded()}
                onKeyDown={this.toggleExpanded}
                className="read-more"
              >{`Read ${expanded ? "less" : "more"}`}</a>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
